import { Cryptocurrency } from '#src/__generated__/globalTypes.ts';
import { SolanaIcon } from '#src/atoms/icons/SolanaIcon.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconEthereum } from '#src/atoms/icons/system/iconEthereum.ts';

type Props = {
  cryptocurrency: Cryptocurrency;
};

export const CryptoIcon = ({ cryptocurrency }: Props) => {
  if (cryptocurrency === Cryptocurrency.WEI) {
    return <FontAwesomeIcon icon={iconEthereum} />;
  }
  return <SolanaIcon />;
};
